export enum ViewsWithSteps {
  UploadDocuments = 'uploadDocuments',
}
